import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Entities } from 'src/app/core/models/globals';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-node-left-panel',
  templateUrl: './node-left-panel.component.html',
  styleUrls: ['./node-left-panel.component.scss'],
})
export class NodeLeftPanelComponent implements OnInit {
  properties = [
    {
      name: 'Nodes',
      routerLink: 'Nodes',
      spanClass: 'bi bi-diagram-3',
    },
    {
      name: 'Logs',
      routerLink: 'Logs',
      spanClass: 'bi bi-body-text',
    },
  ];
  depName = this.route.snapshot.params['deploymentName'] ||this.route.parent.snapshot.params['deploymentName']

  selectedIndex: number;

  constructor(private navService: NavigationService, private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.navService.sendParentData(Entities.Nodes);
    this.navService.index.subscribe(x => {
      this.selectedIndex = x;
    })
    if(this.depName == "All"){
      this.properties[0].routerLink = "Node";
    }
  }

  sendData(index: number, property) {
    if(this.selectedIndex != index ){
      this.selectedIndex = index;
      this.navService.sendParentData(property.name);
      this.navService.sendLeftPanelIndex(index);
      this.router.navigate([property.routerLink], { relativeTo: this.route })
      this.navService.selectedLogType = "Node";
    }
  }
}
